import { render, staticRenderFns } from "./komuni.vue?vue&type=template&id=63740e42&"
import script from "./komuni.vue?vue&type=script&lang=js&"
export * from "./komuni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports